import { AbstractIcon } from "./abstract";
import { componentsRegistryService } from "cruzo";

/** IBM Carbon Design System — catalog icon (32px artboard). */
export class CarbonCatalogIcon extends AbstractIcon {
  static selector = "carbon-catalog-icon";

  getHTML() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">
      <path d="M26,2H8A2,2,0,0,0,6,4V8H4v2H6v5H4v2H6v5H4v2H6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H8V24h2V22H8V17h2V15H8V10h2V8H8V4H26Z"/>
      <rect x="14" y="8" width="8" height="2"/>
      <rect x="14" y="15" width="8" height="2"/>
      <rect x="14" y="22" width="8" height="2"/>
    </svg>`;
  }
}

componentsRegistryService.define(CarbonCatalogIcon);
